/*
* error 提示
* */

'use strict';
var React = require('react');
var i18n = require('../helper/i18n');

var AppError = React.createClass({
  propTypes: {
    error: React.PropTypes.object
  },
  render: function () {
    return (
      <div className="app-error">
        <h1>{i18n.get('FAIL_TO_LOAD')}</h1>
        <p>{i18n.get('ERROR')} {this.props.error.message}</p>
        <p>{i18n.get('HELP')}</p>
        {window.isDev && <button onClick={this.refresh}>刷新</button>}
      </div>
    );
  },
  refresh: function () {
    window.localStorage.path = '';
    window.location.reload();
  }
});

module.exports = AppError;



// WEBPACK FOOTER //
// ./src/views/AppError.jsx